module.exports = __webpack_public_path__ + "img/companyInfo.71496cf0.png";